/**
 * LayoutPreviewButton
 * --------------------------------------------------------------
 * Small button that opens a sample-invoice PDF for the given layout in a new
 * tab. Used next to every "PDF Layout" dropdown so users can see what the
 * layout looks like before saving the choice.
 */
import { Eye } from 'lucide-react';
import { toast } from 'sonner';

export default function LayoutPreviewButton({ layout, label = 'Preview' }) {
  const handleClick = async () => {
    const effective = (layout || 'classic');
    if (!effective || effective === '') {
      toast.error('Pick a layout first');
      return;
    }
    try {
      const API = process.env.REACT_APP_BACKEND_URL;
      const token = localStorage.getItem('erp_token') || localStorage.getItem('access_token') || localStorage.getItem('token');
      const res = await fetch(`${API}/api/preview/layout/${effective}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) { toast.error('Preview failed'); return; }
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank', 'noopener,noreferrer');
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch {
      toast.error('Could not load preview');
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="inline-flex items-center gap-1 rounded-md border border-input bg-background px-2.5 py-1 text-xs font-medium hover:bg-accent"
      title="Open a sample PDF in this layout"
      data-testid="layout-preview-btn"
    >
      <Eye size={12} /> {label}
    </button>
  );
}
